import ReactSpeedometer from "react-d3-speedometer";

interface GaugeChartProps {
  value: number;
  height?: number;
  width?: number;
}

const GaugeChart: React.FC<GaugeChartProps> = (props) => {
  const { value, height = 300, width = 300 } = props;
  return (
    <ReactSpeedometer
      maxValue={100}
      value={value}
      maxSegmentLabels={0}
      segmentColors={["#F97066", "#FEC84B", "#12B76A"]}
      needleColor="#fff"
      customSegmentStops={[0, 20, 60, 100]}
      segments={3}
      height={height}
      width={width}
      textColor="#fff"
      valueTextFontSize="24px"
    />
  );
};

export default GaugeChart;
